import { Factory } from './factory';
import { BookAdditional, BookAdditionalFile } from '../book-additional';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BookAdditionalFactory implements Factory<BookAdditional> {

    buildFromFactory(): BookAdditional {
        return undefined;
    }

    buildFromObject(jsonObject: any): BookAdditional {
        const bookAdditional = new BookAdditional();
        bookAdditional.id = jsonObject.id;
        bookAdditional.title = jsonObject.title;
        bookAdditional.typeId = +jsonObject.type;
        bookAdditional.typeIconUrl = jsonObject.typeIconUrl;
        bookAdditional.cover = jsonObject.cover;

        if (jsonObject.lastUpdate) {
            bookAdditional.lastUpdated = new Date(jsonObject.lastUpdate.substr(0, 10));
        }
        bookAdditional.productLink = jsonObject.productLink;
        bookAdditional.files = [];

        jsonObject.files.forEach(ele => {

            const bookAdditionalFile = new BookAdditionalFile();
            bookAdditionalFile.title = ele.title;
            bookAdditionalFile.link = ele.link;
            bookAdditionalFile.bookLink = ele.bookLink;
            bookAdditionalFile.isExcel = ele.isExcel;
            bookAdditionalFile.isWord = ele.isWord;
            bookAdditionalFile.isPdf = ele.isPdf;
            bookAdditional.files.push(bookAdditionalFile);
        });

        return bookAdditional;
    }
}
